export const SET_SCREENSHOTS = 'SET_SCREENSHOTS'
export const UPDATE_SCREENSHOT_DATA = 'UPDATE_SCREENSHOT_DATA'
export const REMOVE_SCREENSHOT = 'REMOVE_SCREENSHOT'
export const CLEAR_SCREENSHOTS = 'CLEAR_SCREENSHOTS'
